import {
    handleHorizontalMovement,
    handleOmnidirectionalMovement,
    handleVerticalMovement,
} from './helpers'

export const DRAGGABLE_ITEM_TYPES = {
    ListItem: 'ListItem',
    PinnedSidebarPage: 'PinnedSidebarPage',
}

export enum DRAG_DIRECTION {
    VERTICAL = 'Vertical',
    HORIZONTAL = 'Horizontal',
    OMNIDIRECTIONAL = 'Omnidirectional',
}

export const DragHandlers = {
    [DRAG_DIRECTION.VERTICAL]: handleVerticalMovement,
    [DRAG_DIRECTION.HORIZONTAL]: handleHorizontalMovement,
    [DRAG_DIRECTION.OMNIDIRECTIONAL]: handleOmnidirectionalMovement,
}
